import { Constants } from "../constants";
export default {
  setEquipmentEventsList(payload: any) {
    return {
      payload,
      type: Constants.SET_HYDRIQUE_EQUIPMENT_EVENT_LIST,
    };
  },
  setLatestEvent(payload: any) {
    return {
      payload,
      type: Constants.SET_HYDRIQUE_LATEST_EVENT_EQUIPMENT,
    };
  },
};
